export const TabType = {
    Singpass: 0,
    StudentId: 1
};

export const RetrieveType = {
    Singpass: 0,
    EmailOTP: 1
};

export const ReenableType = {
    Singpass: 0,
    EmailOTP: 1
};